export const getNormalizedText = (value: string): string => value.trim();

export const hasSubmittableText = (value: string): boolean => getNormalizedText(value).length > 0;
